import type { TLayoutsListParams } from 'app/queries/layouts/layoutsKeys';

export type TLayoutSort = Pick<TLayoutsListParams, 'orderBy' | 'orderType'>;

export const LAYOUT_SORT_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'createdAt:desc', label: 'Newest first' },
  { value: 'createdAt:asc', label: 'Oldest first' },
  { value: 'updatedAt:desc', label: 'Recently updated' },
  { value: 'name:asc', label: 'Name A to Z' },
  { value: 'name:desc', label: 'Name Z to A' },
  { value: 'templateName:asc', label: 'Template A to Z' },
];

export const DEFAULT_LAYOUT_SORT: TLayoutSort = { orderBy: 'createdAt', orderType: 'desc' };

export const buildLayoutSortValue = ({ orderBy, orderType }: TLayoutSort) => `${orderBy}:${orderType}`;

export const parseLayoutSortValue = (value: string): TLayoutSort => {
  const isKnown = LAYOUT_SORT_OPTIONS.some((option) => option.value === value);
  if (!isKnown) {
    return DEFAULT_LAYOUT_SORT;
  }
  const [orderBy, orderType] = value.split(':');
  return { orderBy, orderType: orderType === 'asc' ? 'asc' : 'desc' };
};
